<template>
  <b-form-select
    v-bind="$attrs"
    :options="options"
    @change="handleChange"
    v-model="selectAccountManager"
    class="form-control"
  >
    <template #first>
      <b-form-select-option :value="null">
        Gestor
      </b-form-select-option>
    </template>
  </b-form-select>
</template>

<script>
import { Api } from '../../vue/api';
const API = new Api();

export default {
  props: {
    value: {
      type: [String, Number],
      default: null,
    },
    optionsData: {
      type: Array,
      default() {
        return [];
      },
      required: false,
    },
  },
  data() {
    return {
      selectAccountManager: this.value,
      options: [],
    };
  },
  async mounted() {
    if (this.optionsData.length) {
      this.options = this.optionsData;
      return;
    }
    const storedOptions = localStorage.getItem('accountManagerOptions');
    if (storedOptions) {
      this.options = JSON.parse(storedOptions);
      return;
    }
    await this.getAccountManager();
  },
  methods: {
    async getAccountManager() {
      /** @type {{ok: boolean, model: any[], errors: Object}} */
      const { ok, model, errors } = await API.post('/execute', {
        path: `/admin-user-operations`,
        method: 'get',
      });
      if (!ok) {
        this.$bvToast.toast(errors.message, {
          title: `Erro`,
          variant: 'error',
          solid: true,
        });
        return;
      }
      const options = model.map(user => ({
        value: user.id.toString(),
        text: user.name.toUpperCase(),
      }));

      localStorage.setItem('accountManagerOptions', JSON.stringify(options));
      this.options = options;
    },
    handleChange() {
      this.$emit('input', this.selectAccountManager);
    },
  },
};
</script>
